module.exports = __webpack_public_path__ + "img/icon-depi-inactive.4bd1e1ac.png";